<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue';
import Button from "../../common/Button.vue";

const props = defineProps({
    index: {
        type: Number,
        required: true
    },
    editor: {
        type: Object,
        required: true
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;
const router = proxy.$router;

// --- State ---

const item = ref(null);

// --- Computed ---

const activeEditorKey = computed(() => store.state.themes.activeEditorKey);

const typeColourClass = computed(() => {
    const classNames = {
        'templates_templates': '',
        'themes_javascript': 'text-danger',
        'themes_css': 'text-success',
    };
    return classNames[props.editor.tableName] || '';
});

// --- Async Logic (Replaces asyncComputed) ---

watch(() => [props.editor.tableName, props.editor.id], async () => {
    item.value = await store.dispatch('itemData/get', {
        tableName: props.editor.tableName,
        id: props.editor.id
    });
}, { immediate: true });

// --- Methods ---

const selectTab = () => {
    router.push({
        query: {
            section: props.editor.sectionName,
            id: props.editor.id
        }
    });
};

const removeEditor = () => {
    if (!props.editor.isModified || confirm('Are you sure?')) {
        store.dispatch('themes/removeEditorByIndex', {
            router: router,
            key: props.index
        });
    }
};
</script>

<template>
    <Button
        v-if="item"
        class="btn-sm me-1 p-1 d-flex align-items-center text-nowrap"
        @click.prevent.native="selectTab"
        :active-value="index === activeEditorKey"
        :active-class="'btn-primary'"
        :default-class="typeColourClass"
    >
        <i class="me-1 bi-x" @click.stop.prevent="removeEditor"></i>

        <small>{{ item.title }}</small>

        <span :class="{ 'bg-warning': editor.isModified }" class="rounded ps-1 pt-1 ms-2 me-1"/>
    </Button>
</template>

<style scoped>
/* Shows the 'X' (remove icon) only on hover */
button > :first-child {
    visibility: hidden;
}

button:hover > :first-child {
    visibility: visible;
}
</style>